(() => {
  'use strict';
  if (window.OleaReviewSummary) return;
  const integer = value => (typeof value === 'number' || typeof value === 'string' && value.trim() !== '') && Number.isSafeInteger(Number(value)) && Number(value) >= 0 ? Number(value) : null;
  const normalize = raw => {
    if (!raw || typeof raw !== 'object') return null;
    const total = integer(raw.total_reviews);
    if (total === null) return null;
    const counts = [1, 2, 3, 4, 5].map(star => integer(raw[`total_star${star}`] ?? raw.counts?.[star] ?? raw[star]?.count ?? raw[star]));
    if (counts.some(value => value === null) || counts.reduce((a, b) => a + b, 0) !== total) return null;
    const average = raw.rating !== null && raw.rating !== undefined && raw.rating !== '' ? Number(raw.rating) : NaN;
    return {total, counts, average: Number.isFinite(average) && average >= 0 && average <= 5 ? average : null};
  };
  const text = (node, value) => { if (node && node.textContent !== value) node.textContent = value; };
  const fillTemplate = (template, values) => Object.entries(values).reduce((value, [key, replacement]) => value.replaceAll(`__${key}__`, String(replacement)), template || '');
  const updateScore = (summary, raw) => {
    if (!summary || !raw) return false;
    const total = integer(raw.total_reviews);
    const average = raw.rating !== null && raw.rating !== undefined && raw.rating !== '' ? Number(raw.rating) : NaN;
    if (total === null) return false;
    const locale = document.documentElement.lang || 'fr';
    const number = new Intl.NumberFormat(locale);
    const countTemplate = total === 1 ? summary.dataset.reviewCountOneLabel : summary.dataset.reviewCountLabel;
    text(summary.querySelector('[data-review-count]'), fillTemplate(countTemplate, {count: number.format(total)}));
    if (!Number.isFinite(average) || average < 0 || average > 5 || total > 0 && average === 0) return true;
    const label = summary.querySelector('[data-review-average]');
    if (label) {
      let value = label.querySelector('span');
      if (!value) { value = document.createElement('span'); label.replaceChildren(value); }
      if (total > 0) {
        const formatted = new Intl.NumberFormat(locale, {minimumFractionDigits: 1, maximumFractionDigits: 1}).format(average);
        value.setAttribute('data-ol-count', formatted);
        text(value, formatted);
      } else {
        value.removeAttribute('data-ol-count');
        text(value, summary.dataset.reviewEmptyLabel || '—');
      }
    }
    summary.querySelector('[data-review-stars]')?.style.setProperty('--rating-fill', `${total > 0 ? average * 20 : 0}%`);
    return true;
  };
  const update = (summary, raw) => {
    const data = normalize(raw);
    if (!summary || !data) return false;
    const locale = document.documentElement.lang || 'fr';
    const number = new Intl.NumberFormat(locale);
    const percent = new Intl.NumberFormat(locale, {maximumFractionDigits: 1});
    summary.dataset.distributionState = 'known';
    summary.dataset.reviewTotal = String(data.total);
    summary.querySelectorAll('[data-rating-level]').forEach(row => {
      const star = Number(row.dataset.ratingLevel), count = data.counts[star - 1];
      const share = data.total ? count / data.total * 100 : 0;
      const label = percent.format(share);
      row.dataset.reviewStarCount = String(count);
      row.setAttribute('aria-label', fillTemplate(summary.dataset.reviewRowLabel, {stars: row.dataset.reviewStarLabel, count: number.format(count), percent: label}));
      text(row.querySelector('[data-review-percent]'), `${label} %`);
      const fill = row.querySelector('.olea-review-distribution__fill');
      if (fill) {
        fill.style.width = `${share}%`;
        fill.removeAttribute('data-ol-bar');
        fill.classList.remove('is-armed', 'is-in');
      }
    });
    const status = summary.querySelector('[data-review-distribution-status]');
    if (status) status.hidden = true;
    updateScore(summary, raw);
    return true;
  };
  window.OleaReviewSummary = {normalize, update, updateScore};
})();
